import { CustomPreloadingStrategy } from '@app/shared/custom-preloading-strategy.service';
import { RouterModule, Routes } from '@angular/router';

const routes: Routes = [
  {
    path: 'inquiry',
    loadChildren: () => import('@app/inquiry/inquiry.module').then((m) => m.InquiryModule)
  },
  {
    path: 'reports',
    loadChildren: () =>
      import('@app/reports/custom-reports/custom-reports.module').then((m) => m.CustomReportsModule)
  },
  {
    path: 'batch-load-screen',
    loadChildren: () =>
      import('@app/batch-load-screen/batch-load-screen.module').then((m) => m.BatchLoadScreenModule)
  },
  {
    path: 'employees',
    loadChildren: () =>
      import('@app/employees/employee-maintenance/employee-maintenance.module').then(
        (m) => m.EmployeeMaintenanceModule
      )
  },
  {
    path: 'pumpers',
    loadChildren: () =>
      import('@app/pumper/pumper-maintenance/pumper-maintenance.module').then(
        (m) => m.PumperMaintenanceModule
      )
  },
  {
    path: 'jobs',
    loadChildren: () =>
      import('@app/jobs/job-maintenance/job-maintenance.module').then((m) => m.JobMaintenanceModule)
  },
  {
    path: 'trucks',
    loadChildren: () => import('@app/trucks/trucks.module').then((m) => m.TrucksModule)
  },
  {
    path: 'plants',
    loadChildren: () => import('@app/plants/plants.module').then((m) => m.PlantsModule)
  },
  {
    path: 'quote',
    loadChildren: () => import('@app/quotes/quotes.module').then((m) => m.QuotesModule)
  },
  {
    path: 'bg',
    loadChildren: () => import('@app/blank/blank.module').then((m) => m.BlankModule)
  },
  {
    path: 'debug',
    loadChildren: () => import('@app/debug/debug.module').then((m) => m.DebugModule)
  },
  {
    path: 'orders',
    loadChildren: () => import('@app/orders/orders.module').then((m) => m.OrdersModule),
    data: { preload: true }
  },
  {
    path: 'security',
    loadChildren: () => import('@app/security/security.module').then((m) => m.SecurityModule)
  },
  {
    path: 'ticketing',
    loadChildren: () => import('@app/ticketing/ticketing.module').then((m) => m.TicketingModule)
  },
  {
    path: 'load-scheduling',
    loadChildren: () =>
      import('@app/truck-tracking/truck-tracking.module').then((m) => m.TruckTrackingModule)
  },
  {
    path: 'customers',
    loadChildren: () => import('@app/customers/customers.module').then((m) => m.CustomersModule)
  },
  {
    path: 'products',
    loadChildren: () => import('@app/products/products.module').then((m) => m.ProductsModule)
  },
  {
    path: 'home',
    loadChildren: () => import('@app/home/home.module').then((m) => m.HomeModule),
    data: { preload: true }
  },
  {
    path: '',
    loadChildren: () => import('@app/security/login/login.module').then((m) => m.LoginModule)
  },
  {
    path: '**',
    redirectTo: 'home'
  }
];

export const appRoutes = RouterModule.forRoot(routes, {
  enableTracing: false,
  preloadingStrategy: CustomPreloadingStrategy
});
